import { Container, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import Ekomi from 'components/Stage/Ekomi';
import TuvCertificate from 'components/Stage/TuvCertificate';

const ColoredBackground = styled(Container)`
  background-color: ${({ theme }) => theme.palette.grey[50]};
  border-radius: ${({ theme }) => theme.spacing()};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing(7)};
  padding: ${({ theme }) => theme.spacing(4)} min(15%, 180px) !important;

  ${({ theme }) => theme.breakpoints.down('md')} {
    display: block;
    border-radius: 0;
    padding: ${({ theme }) =>
      `${theme.spacing(4)} ${theme.spacing(3)}`} !important;
  }
`;

const CertificateWrapper = styled('div')`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(4)};
  flex-shrink: 0;

  ${({ theme }) => theme.breakpoints.down('md')} {
    justify-content: center;
    margin-top: ${({ theme }) => theme.spacing(3)};

    & > * {
      margin: 0 !important;
    }
  }
`;

interface TrustBannerProps {
  title: string;
}
export const TrustBanner = ({ title }: TrustBannerProps) => {
  return (
    <ColoredBackground>
      <Typography variant="h2">{title}</Typography>
      <CertificateWrapper>
        <div>
          <TuvCertificate />
        </div>
        <Ekomi />
      </CertificateWrapper>
    </ColoredBackground>
  );
};
